"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { classNames } from "../../utilities/props.js";
import { getFocusableElements } from "../../utilities/a11y/index.js";
import { useTabs } from "./TabsContext.js";
import s from "./Tabs.module.css";
const TabsPanel = (props) => {
    const { value: panelValue, children, className, attributes } = props;
    const { value, panelId, buttonId } = useTabs(panelValue);
    const [needsTabIndex, setNeedsTabIndex] = React.useState(true);
    const rootRef = React.useRef(null);
    const active = panelValue === value;
    const panelClassNames = classNames(s.panel, !active && s["--panel-hidden"], className);
    React.useEffect(() => {
        const el = rootRef.current;
        if (!el)
            return;
        const updateTabIndex = () => {
            setNeedsTabIndex(!getFocusableElements(el).length);
        };
        updateTabIndex();
        const observer = new MutationObserver(updateTabIndex);
        observer.observe(el, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["tabindex", "disabled", "href"],
        });
        return () => observer.disconnect();
    }, []);
    return (_jsx("div", { ...attributes, ref: rootRef, className: panelClassNames, tabIndex: needsTabIndex ? 0 : undefined, role: "tabpanel", id: panelId, "aria-labelledby": buttonId, children: active && children }));
};
TabsPanel.displayName = "Tabs.Panel";
export default TabsPanel;
